if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Todo: Add loading state to button...
      // this.button.setAttribute('aria-disabled', true);
      // this.button.classList.add('loading');
      // this.button.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const variant = this.button.dataset.variant;
      const newVariant = this.button.dataset.newVariant;
      const sellingPlan = this.button.dataset.sellingPlan;
      const itemLine = this.button.dataset.line;

      // Base data for both swapping and subscribing.
      const data = {
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
      let route;

      // If we have newVariant, we need the /update endpoint with 'updates' object and variant properties.
      if (newVariant) {
        const variants = {
          [variant]: 0,
          [newVariant]: 1
        }

        data.updates = variants;
        route = `${routes.cart_update_url}`;

      } else if (sellingPlan) {
        // If we have sellingPlan, we need the /change endpoint with 'id' and 'quantity'properties.
        data.line = itemLine;
        data.quantity = 1;
        data.selling_plan = sellingPlan;
        route = `${routes.cart_change_url}`;
      }

      //this.enableLoading(line);
      const body = JSON.stringify(data);
      console.log(body);

      fetch(`${route}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.button.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.button.setAttribute('aria-disabled', true);
            this.button.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          this.cart.renderContents(response);
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.button.removeAttribute('aria-disabled');
          //this.button.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}